/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useState, useEffect, useMemo, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import {
  HomeFilled,
  CalculatorFilled,
  FundFilled,
  ContainerFilled,
  ReadFilled,
  MenuOutlined,
} from '@ant-design/icons';
import Tippy from '@tippyjs/react/headless';
import { Redirect, NavLink, useLocation } from 'react-router-dom';
import 'tippy.js/dist/tippy.css';

import { LoadingScreen } from 'components/loadingScreen';

import './index.scss';

const NavigationItems = [
  // { key: 1, label: "Home", value: "Home", toPath: "/", icon: <HomeFilled /> },
  {
    key: 2,
    label: 'Data Input',
    value: 'Data Input',
    toPath: '/calculator',
    icon: <CalculatorFilled />,
  },
  {
    key: 3,
    label: 'Results',
    value: 'Results',
    toPath: '/results',
    icon: <FundFilled />,
  },
  {
    key: 4,
    label: 'User Library',
    value: 'User Library',
    toPath: '/user-library',
    icon: <ReadFilled />,
  },
  {
    key: 5,
    label: 'Example Library',
    value: 'Example Library',
    toPath: '/example-library',
    icon: <ContainerFilled />,
  },
];

const Navigation = () => {
  const location = useLocation();

  const showGlobalSpinner = useSelector(
    (state) => state.dataReducers.showGlobalSpinner
  );

  const [currentPage, setCurrentPage] = useState(location.pathname);
  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    setCurrentPage(location.pathname);
  }, [location]);

  useEffect(() => {
    setScreenWidth(window.innerWidth);
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);

    return function cleanup() {
      window.removeEventListener('resize', handleResize);
    };
  }, [screenWidth]);

  const SmallScreenNavigation = ({ ...props }) => {
    return (
      <ul {...props} className='small-screen-navigation'>
        {NavigationItems.map((item) => (
          <li key={item.key}>
            <NavLink
              key={item.key}
              to={item.toPath}
              onClick={() => setCurrentPage(item.toPath)}
              css={AppNavItemStyle(item.toPath === currentPage)}
            >
              {item.icon}
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div css={AppHeaderStyle}>
      <Row>
        <Col sm={5} md={5} css={AppTitleColumn}>
          <NavLink css={AppTitleStyle} to='/'>
            {/* <img
              src={`${process.env.PUBLIC_URL}/images/ies-logo.jpg`}
              alt="IES Logo"
            /> */}
            <h1>Spectral Calculator</h1>
            <LoadingScreen show={showGlobalSpinner === 'globalSpin'} />
          </NavLink>
        </Col>
        <Col sm={7} md={7}>
          {screenWidth >= 992 ? (
            <div css={AppNavContainer}>
              {NavigationItems.map((item) => (
                // <div css={AppNavItemStyle(item.toPath === currentPage)}>
                <NavLink
                  key={item.key}
                  to={item.toPath}
                  onClick={() => setCurrentPage(item.toPath)}
                  css={AppNavItemStyle(item.toPath === currentPage)}
                >
                  {item.icon}
                  {item.label}
                </NavLink>
                // </div>
              ))}
            </div>
          ) : (
            <div className='tippy-nav-item'>
              <Tippy
                render={(props) => <SmallScreenNavigation {...props} />}
                offset={[0, 0]}
                interactive
                placement='bottom'
                trigger='mouseenter focus click'
              >
                <MenuOutlined css={BurgerIcon} />
              </Tippy>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Navigation;

const AppTitleColumn = css`
  display: flex;

  svg {
    width: 4rem;
    height: auto;
    margin: 0 1rem;
  }
`;

const AppHeaderStyle = css`
  padding: 0 10px;
  background-color: #fff;
  overflow: hidden;

  sup {
    font-size: 14px;
    top: -18px;
  }
`;

const AppTitleStyle = css`
  display: flex;
  cursor: pointer;
  text-decoration: none !important;
  width: fit-content;

  h2,
  h3 {
    margin: 18px 10px;
  }
  img {
    width: 50px;
    height: 55px;
    padding: 15px 0px 0px 10px;
  }
`;

const AppNavContainer = css`
  display: flex;
  justify-content: flex-end;
  a {
    margin: 0 2rem;
  }

  @media (max-width: 1056px) {
    justify-content: space-evenly;
    a {
      margin: 0;
    }
  }
`;

const AppNavItemStyle = (isActive) => css`
  font-size: 18px;
  cursor: pointer;
  color: #47494c !important;
  text-decoration: none !important;
  //margin: 0 2rem;

  span {
    margin-right: 6px;
    font-size: 22px;
    border: none;
    color: #47494c;
  }

  :hover,
  :focus {
    border-bottom: 6px solid #d6781e;
  }

  border-bottom: ${isActive ? '6px solid #d6781e' : ''};
`;

const BurgerIcon = css`
  font-size: 4rem !important;
`;
